<script lang="ts">
import { defineComponent, PropType, toRef } from 'vue'
import InputLeadFormWrapper from '@/components/lead/InputLeadFormWrapper.vue'
import MultiSelectorDefault from '@/components/form/MultiSelectorDefault.vue'
import { formDefaultProps, formPartial } from '@/models/formPartial'

export default defineComponent({
  name: 'MultiSelectorForm',

  components: {
    InputLeadFormWrapper,
    MultiSelectorDefault,
  },

  props: {
    ...formDefaultProps,

    /**
     * 初期選択状態が bind される value
     */
    modelValue: {
      type: Array as PropType<MultiSelect>,
      required: true,
    },

    /**
     * 選択肢の項目情報
     */
    items: {
      type: Array as PropType<SelectorOption[]>,
      required: true,
    },

    /**
     * <option> の末尾に付与される単位
     * 任意プロパティ
     *
     * @example unit="個" => <option>1個</option>
     */
    unit: {
      type: String,
      default: '',
    },

    placeholder: {
      type: String,
      default: '複数選択できます',
    },

    /**
     * 選択のリセットボタンを表示するかどうか
     */
    hasReset: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['update:modelValue', 'change'],

  setup(props) {
    const { hasError } = formPartial(props.name, toRef(props, 'validationScheme'))

    return {
      // computed
      hasError,
    }
  }
})
</script>

<template>
  <InputLeadFormWrapper
    :model-value="modelValue"
    :header="header"
    :description="description"
    :namespace="namespace"
    :name="name"
    :is-disabled="isDisabled"
    :validation-scheme="validationScheme"
    is-select-type>
    <MultiSelectorDefault
      :model-value="modelValue"
      :name="name"
      :items="items"
      :unit="unit"
      :placeholder="placeholder"
      :is-disabled="isDisabled"
      :is-error="hasError"
      :has-reset="hasReset"
      @update:model-value="$emit('update:modelValue', $event)"
      @change="$emit('change', $event)" />

    <template #secondary>
      <slot />
    </template>
  </InputLeadFormWrapper>
</template>
